"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.MenuList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@chakra-ui/react");
var menu_button_1 = require("../menu-button/menu-button");
var menu_item_1 = require("../menu-button/menu-item");
var svg_icons_1 = require("../svgs/svg-icons");
// Component to render action menu
var MenuList = function (_a) {
    var options = _a.options;
    var icon = ((0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeVerticalMenu", svgIconClass: "menu-list-icon", svgIconSize: "16" }));
    return (
    //@ts-ignore
    (0, jsx_runtime_1.jsx)(react_1.Grid, __assign({ className: "menu-list" }, { children: (0, jsx_runtime_1.jsx)(menu_button_1.MenuButton, __assign({ icon: icon }, { children: options.map(function (option, idx) { return ((0, jsx_runtime_1.jsx)(menu_item_1.MenuItem, __assign({ onSelect: option.onClick }, { children: option.label }), idx)); }) })) })));
};
exports.MenuList = MenuList;
//# sourceMappingURL=menu-list.js.map